<template>
    <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
        <!-- start of title -->
        <div class="title-box">
            <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
            <span>运营报告对冲申请</span>
        </div>
        <!-- end of title -->

        <!-- start of form -->
        <div class="form-box">
            <!-- start of 付款申请信息 -->
            <div class="back-color-fff mt-4">
                <span class="form-title">对冲流程信息</span>
                <el-form ref="formData">
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label-width="188px" prop="relevance">
                                <span slot="label">
                                    <span style="color: red">*</span>运营报告流程：
                                </span>
                                <el-input style="width:500px" v-model="qualityCheckObj.qualityCheckName"
                                    placeholder="请选择运营报告流程" readonly @focus="focusRelevance(0)">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label-width="188px" prop="relevance">
                                <span slot="label">
                                    <span style="color: red">*</span>是否对冲运营报告：
                                </span>
                                <el-select v-model="isHedgeSource" class="contract-base-content"
                                    placeholder="请选择">
                                    <el-option v-for="item in [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }]"
                                        :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label-width="188px" prop="relevance">
                                <span slot="label">
                                    <span :style="isHedgeSource == 'N' ? 'color: red' : 'color: white'">*</span>关联流程：
                                </span>
                                <div @click="focusRelevance(1)" class="detail" v-html="formatName(relevanceListName)">
                                </div>
                                <div style="color:#999;line-height:30px;" v-if="isHedgeSource=='Y'">关联流程必须全选质量考核、付款通知单和开票流程，会将运营报告以及关联的质量考核、付款通知单和开票流程全部对冲;</div>
                                <div style="color:#999;line-height:30px;" v-if="isHedgeSource=='N'">①选择开票流程时，则对开票流程进行对冲；<br>②选择付款通知单时，必须把开票也要选中，则对付款通知单和开票流程进行对冲；<br>③选择质量考核时，则对质量考核进行对冲；</div>
                            </el-form-item>
                        </el-col>

                    </el-row>

                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label-width="188px" prop="relevance">
                                <span slot="label">
                                    <span style="color: red">*</span>是否对冲付款通知单票据：
                                </span>
                                <el-select v-model="isHedgeInvoice" class="contract-base-content"
                                    placeholder="请选择">
                                    <el-option v-for="item in [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }]"
                                        :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item prop="upstreamInvoiceItem" label-width="188px">
                                <span slot="label">
                                    <span style="color: red">*</span>对冲说明：
                                </span>
                                <el-input style="width:500px" v-model.trim="memo" placeholder="请输入" clearable
                                    maxlength="200" :rows="3" resize="none" type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- end of 付款申请信息 -->

            <!-- start of 流程审批 -->
            <div class="back-color-fff mt-4">
                <!-- <span class="form-title">流程审批</span> -->
                <div class="flow">
                    <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
                </div>
            </div>
            <!-- end of 流程审批 -->

            <!-- start of bottom-btn -->
            <div class="back-color-fff submit_btn_wrap">
                <el-button type="defalut" class="cannel-btn" size="mini" @click=" $router.go(-1)">取消</el-button>
                <el-button type="defalut" v-if="this.$route.query.type != 2" size="mini" @click=" saveForm()">保存</el-button>
                <el-button type="primary" size="mini" @click=" submitForm()">{{ this.$route.query.type == 2 ? '重新提交' :
                    '提交申请'
                }}</el-button>
            </div>
            <!-- end of bottom-btn -->
        </div>
        <!-- end of form -->

        <!-- start of dialog-关联流程 -->
        <el-dialog :title="dialogType == 0 ? '运营报告流程' : '关联流程'" class="flow-dialog" :visible.sync="dialogFormVisible"
        v-loading="dialogLoading"
            width="70%">
            <div class="content-main-box content-main-box2">
                <div class="search-area">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <div class="search-area-div w80">关键字搜索</div>
                            <el-input v-model="page.searchKey" placeholder="请输入企业、组织、应付金额搜索" size="mini" class="ipt-sty">
                            </el-input>
                        </el-col>
                        <el-col :span="6" class="search-btn-box">
                            <el-button size="mini" type="info" @click=" getFlowList()">搜索</el-button>
                            <el-button size="mini" type="danger" @click="empty">清空</el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-table :header-cell-class-name="cellClass" stripe border ref="multipleTable1" highlight-current-row
                    :height="tableHeight" :data="flowLists" :row-key="(row) => row.guid" :current-row-key="currentRowKey"
                    @row-click="flowListsChange" @select="handleSelectFlow">
                    <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
                    <el-table-column prop="flowName" label="流程编号" header-align="center" align="left" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{  scope.row.flowNo || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="flowName" label="流程名称" header-align="center" align="left" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{  scope.row.flowName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 发起人 -->
                    <el-table-column prop="applyStaffName" width="96" label="发起人" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.createUserName || scope.row.staffName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 药企名称 -->
                    <el-table-column prop="tenantName" label="药企名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.bizTenantName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 组织名称 -->
                    <el-table-column prop="organisationName" label="组织名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.bizOrganisationName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 核算月 -->
                    <el-table-column prop="accountMonth" label="核算月" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.accountMonth || scope.row.accountMonthName }}
                        </template>
                    </el-table-column>
                    <!-- 任务包名称 -->
                    <el-table-column prop="taskTitleName" label="任务包名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.taskTitleName || '-'
                        }}</template>
                    </el-table-column>
                    <!-- 应付金额 -->
                    <el-table-column  prop="currentPayAmount" label="应付金额(元)" header-align="center"
                        align="right" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
                    </el-table-column>
                </el-table>


            </div>
            <div slot="footer">
                <el-button plain size="mini" @click=" dialogFormVisible = false">取消</el-button>
                <el-button size="mini" type="info" @click=" selectProcess()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { bpmnroute } from '@/api/apiRoute';
export default {
    data() {
        return {
            dialogLoading: false,
            fullscreenLoading: false,
            url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
            // 关联流程相关
            dialogFormVisible: false,
            page: {
                searchKey: null,
            },
            flowLists: [],
            tableHeight: '37.5vh',
            // 流程图相关
            iframeSh: false,
            iframeSrc: '',

            currentRow: '',
            currentRowKey: '',

            fileSize: serverConfig.FILE_SIZE,
            // personShow: false,

            dialogType: 0,//选择的是质量考核流程
            qualityCheckObj: {},//运营报告流程
            relevanceList: [],//关联流程数组
            relevanceListName: null,//关联流程名称
            memo: null,//备注
            isHedgeSource: 'Y',//是否对冲运营报告
            isHedgeInvoice: 'Y',//是否对冲付款通知单票据
            // tips:'1、是否对冲质量考核是是时，关联流程必须全选上游的运营报告、付款通知单和开票流程，会将质量考核以及关联的上游的运营报告、付款通知单和开票流程全部对冲；如果没有上游则不选；<br>2、是否对冲质量考核是否时，关联流程必填：<br>&nbsp;&nbsp;&nbsp;①选择开票流程时，则对开票流程进行对冲；<br>&nbsp;&nbsp;&nbsp;②选择付款通知单时，必须把开票也要选中，则对付款通知单和开票流程进行对冲；<br>&nbsp;&nbsp;&nbsp;③选择运营报告时，必须要付款通知单和开票也要选中，则对运营报告、付款通知单以及开票流程进行对冲'

        };
    },
    created() {
        // 获取流程数据
        if (this.$route.query.guid) {
            this.guid = this.$route.query.guid;
            this.getDetail();
        } else {
            this.getApprovalList();
        }
    },
    methods: {
        cellClass(row) {
            if (row.columnIndex === 0 && this.dialogType == 0) {
                return 'disabledCheck';
            }
        },

        focusRelevance(type) {
            if (type == 1 && !this.qualityCheckObj.guid) {
                this.$message.error('请先选择运营报告流程！')
                return;
            }
            // 原来的关联流程变为运营报告流程
            this.dialogType = type;
            this.dialogFormVisible = true;

            this.getFlowList();
        },
        /**
         * 保存
         */
        saveForm() {
            if (!this.checkForm()) return;
            this.postFormData(false);
        },
        /**
         * 提交
         */
        submitForm() {
            if (!this.checkForm()) return;
            this.postFormData(true);
        },
        checkForm() {
            if (!this.qualityCheckObj.guid) {
                this.$message.error('运营报告流程不能为空')
                return false;
            }
            if (!this.isHedgeSource) {
                this.$message.error('是否对冲运营报告不能为空')
                return false;
            }
            if (this.isHedgeSource == 'N' && this.relevanceList && !this.relevanceList.length) {
                this.$message.error('关联流程不能为空')
                return false;
            }
            if (!this.isHedgeInvoice) {
                this.$message.error('是否对冲付款通知单票据不能为空')
                return false;
            }
            if (!this.memo) {
                this.$message.error('对冲说明不能为空')
                return false;
            }
            return true;
        },
        postFormData(flag) {
            let self = this;
            let userInfo=JSON.parse(localStorage.userInfo);
            //运营报告
            let qualityCheckObj = this.qualityCheckObj;
            //关联流程
            let relevanceList = this.relevanceList;
            let hedgeRelationInfoList = [];
            relevanceList.forEach(item => {
                hedgeRelationInfoList.push({
                    "guid": item.guid,
                    "flowName": item.flowName,
                    "flowType": item.flowType,
                })
            })
            let postData = {
                "serviceTenantGuid": localStorage.guid,
                "serviceTenantName": userInfo.tenantName,
                "tenantGuid": qualityCheckObj.bizTenantGuid,
                "tenantName": qualityCheckObj.bizTenantName,
                "organisationGuid": qualityCheckObj.organisationGuid,
                "organisationName": qualityCheckObj.bizOrganisationName,
                "hedgeSourceGuid": qualityCheckObj.guid,
                "hedgeSourceText": qualityCheckObj.qualityCheckName,//运营报告文本
                "accountMonth": qualityCheckObj.accountMonthName,
                // "staffNum": qualityCheckObj.peopleNum,
                // "totalAmount": qualityCheckObj.totalMoney,
                "remarks": this.memo,
                "hedgeRelationInfoList": hedgeRelationInfoList.length ? hedgeRelationInfoList : null,//关联流程的数组
                "currentTenantGuid": localStorage.guid,
                "isSendFlowFlag": flag ? 'Y' : 'N',
                "hedgeRelationInfoText": this.relevanceListName || null,//关联流程文本
                "isHedgeSource": this.isHedgeSource,
                "isHedgeInvoice": this.isHedgeInvoice,
            };
            if (this.$route.query.guid) {
                postData['guid'] = this.$route.query.guid
                this.fullscreenLoading = true;
                self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/hedge/update`, postData).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        if (flag) {
                            self.$message.success('提交成功！');
                        } else {
                            self.$message.success('保存成功！');
                        }
                        self.$router.go(-1);
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });

            } else {
                this.fullscreenLoading = true;
                self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/hedge/add`, postData).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        if (flag) {
                            self.$message.success('提交成功！');
                        } else {
                            self.$message.success('保存成功！');
                        }
                        self.$router.go(-1);
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
            }
        },
        async checkUpstreamHedge() {
            let userInfo=JSON.parse(localStorage.userInfo);
            //运营报告
            let qualityCheckObj = this.qualityCheckObj;
            //关联流程
            let relevanceList = this.relevanceList;
            let hedgeRelationInfoList = [];
            relevanceList.forEach(item => {
                hedgeRelationInfoList.push({
                    "guid": item.guid,
                    "flowName": item.flowName,
                    "flowType": item.flowType,
                })
            })
            let postData = {
                "serviceTenantGuid": localStorage.guid,
                "serviceTenantName": userInfo.tenantName,
                "tenantGuid": qualityCheckObj.bizTenantGuid,
                "tenantName": qualityCheckObj.bizTenantName,
                "organisationGuid": qualityCheckObj.organisationGuid,
                "organisationName": qualityCheckObj.bizOrganisationName,
                "hedgeSourceGuid": qualityCheckObj.guid,
                "hedgeSourceText": qualityCheckObj.qualityCheckName,//运营报告文本
                "accountMonth": qualityCheckObj.accountMonthName,
                "remarks": this.memo,
                "hedgeRelationInfoList": hedgeRelationInfoList.length ? hedgeRelationInfoList : null,//关联流程的数组
                "currentTenantGuid": localStorage.guid,
                "isSendFlowFlag": 'N',
                "hedgeRelationInfoText": this.relevanceListName || null,//关联流程文本
                "isHedgeSource": this.isHedgeSource,
                "isHedgeInvoice": this.isHedgeInvoice,
            };
            const {data} = await this.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/hedge/check`, postData);
            if (data.code !== serverConfig.REQUIRE_SUCCESS_CODE) {
                this.qualityCheckObj = {};
                this.$message.error(data.msg);
                return false;
            }
            return true;
        },
        /**
         * 选择流程
         */
        async selectProcess() {
            let { currentRow } = this;
            console.log('jjj',currentRow);
            
            if (this.dialogType == 0) {
                if (!currentRow['guid']) return this.$message.error('请选择运营报告流程');
                this.qualityCheckObj = currentRow;
                this.qualityCheckObj.qualityCheckName = currentRow.staffName + '_' + currentRow.bizTenantName + '_' + currentRow.accountMonthName + '_' + this.formatMoney(currentRow.currentPayAmount) + '(元)';
                //清空关联的流程
                this.relevanceList = [];
                this.relevanceListName = null;
                if (this.isHedgeSource == 'N') {
                    // 不是对冲运营报告，不需要校验
                    this.dialogFormVisible = false;
                    return;
                }
                // const f = await this.checkUpstreamHedge();
                // if (!f) return;
                this.dialogFormVisible = false;
                
            }
            if (this.dialogType == 1) {
                
                if (this.$refs.multipleTable1.selection.length == 0) return this.$message.error('请选择关联流程');
                this.relevanceList = this.$refs.multipleTable1.selection;
                let nameList = [];
                this.relevanceList.forEach(item => {
                    nameList.push(item.flowName + '_' + item.staffName + '_' + item.bizTenantName + '_' + item.accountMonthName + '_' + this.formatMoney(item.currentPayAmount) + '(元)')
                })
                this.relevanceListName = nameList.join('、');
                this.dialogFormVisible = false;
            }
        },
        //获取详情
        getDetail() {
            let detail = JSON.parse(this.$route.query.detail);
            console.log('detail',detail);
            
            //质量考核
            this.qualityCheckObj = {
                serviceTenantGuid: localStorage.guid,
                bizTenantGuid: detail.tenantGuid,
                bizTenantName: detail.tenantName,
                organisationGuid: detail.organisationGuid,
                bizOrganisationName: detail.organisationName,
                guid: detail.hedgeSourceGuid,
                qualityCheckName: detail.hedgeSourceText,
                accountMonth: detail.accountMonth,
                peopleNum: detail.staffNum,
                totalMoney: detail.totalAmount
            }
            let relevanceList = [];
            if (detail.hedgeRelationInfoList && detail.hedgeRelationInfoList.length) {
                detail.hedgeRelationInfoList.forEach(item => {
                    relevanceList.push({
                        flowName: item.flowName,
                        flowType: item.flowType,
                        guid: item.guid
                    })
                })

            }

            this.relevanceList = relevanceList;
            this.memo = detail.remarks;
            this.relevanceListName = detail.hedgeRelationInfoText;
            this.isHedgeSource = detail.isHedgeSource;
            this.isHedgeInvoice = detail.isHedgeInvoice;
            this.getApprovalList();
        },
        getFlowList() {
            let reqUrl = '/upstream/list';
            let req = null;
            this.flowLists=[]
            let userInfo = JSON.parse(localStorage.userInfo);
            this.dialogLoading = true;

            if (this.dialogType == 0) {
                this.page = {
                    "searchKey": this.page.searchKey,
                    "pageIndex": 1,
                    "pageSize": -1,
                    "approveState": "Y",
                    "searchCode": "A002",
                    "flowType": "00016",
                    "isUsedOperationReport":'',
                    // "qualityCheckGuid": this.qualityCheckObj.guid,
                    "flowStaffGuids": [userInfo.staffGuid]
                }
                req = this.page;
                this.api.postJson(`/${serverConfig.msSalesPerformService}${reqUrl}`, req).then((res) => {
                let { code, msg, data } = res.data;
                this.dialogLoading = false;
                if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.flowLists = data.records || [];
                } else {
                    this.$message.error(msg);
                }
            });
            }
            if (this.dialogType == 1) {
                
                if (this.page.searchKey) {
                    reqUrl = `/upstream/hedge/get-relation-list?hedgeSourceGuid=${this.qualityCheckObj.guid}&searchKey=${this.page.searchKey}`
                } else {
                    reqUrl = `/upstream/hedge/get-relation-list?hedgeSourceGuid=${this.qualityCheckObj.guid}`
                }
                this.api.get(`/${serverConfig.msSalesPerformService}${reqUrl}`).then((res) => {
                let { code, msg, data } = res.data;
                this.dialogLoading = false;

                if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.flowLists = data.records || [];
                    this.$refs.multipleTable1.clearSelection();
                    this.$refs.multipleTable1.toggleAllSelection()
                   
                } else {
                    this.$message.error(msg);
                }
            });
            }
            

           
        },

        flowListsChange(row) {
            if (this.dialogType == 0) {
                this.$refs.multipleTable1.clearSelection();
                row.flag = !row.flag;
                this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
                this.currentRowKey = row.guid;
                this.currentRow = row;
            }
        },
        handleSelectFlow(selection, row) {
            if (this.dialogType == 0) {
                this.$refs.multipleTable1.clearSelection();
                if (selection.length == 0) {
                    return;
                }
                if (row) {
                    this.currentRow = row;
                    this.currentRowKey = row.guid;
                    this.$refs.multipleTable1.toggleRowSelection(row, true);
                }
            }
            console.log(selection);
        },
        /**
         * 清空条件搜索,重新获取流程列表数据
         */
        empty() {
            this.page.searchKey = null;
            this.getFlowList();
        },
        /**
         * 获取流程列表
         */
        async getApprovalList() {
            const userInfo = JSON.parse(localStorage.userInfo);
            try {
                const req = {
                    tenantGuid: localStorage.guid,
                    flowType: '00026',
                    staffGuid: userInfo.staffGuid,
                };
                const res = await this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req);
                if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (res.data.data) {
                        this.iframeSh = true;
                        this.iframeSrc = `${bpmnroute}/iframeBpmn?camundaDeploymentId=${res.data.data}&token=${localStorage.token}`;
                    } else {
                        this.$message.error('未获取到流程信息');
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            } catch (error) {
                this.$message.error('请求出错');
            }
        },


        /**
         * 数字金额转大写
         * @param {*} num 
         */
        convertToChinese(num) {
            const digits = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
            const decimals = ['角', '分'];
            const cnIntRadice = ['', '拾', '佰', '仟'];
            const cnIntUnits = ['', '万', '亿', '兆'];

            let cnNum = '';
            let isNegative = false;

            if (num < 0) {
                isNegative = true;
                num = Math.abs(num);
            }

            let parts = String(num).split('.');
            let integerPart = parts[0];
            let decimalPart = parts[1];

            if (Number(integerPart) === 0) {
                cnNum = digits[0];
                return cnNum;
            }

            let intLen = integerPart.length;
            let zeroCount = 0;

            for (let i = 0; i < intLen; i++) {
                let n = parseInt(integerPart.charAt(i));
                let p = intLen - i - 1;
                let q = p / 4;
                let m = p % 4;

                if (n === 0) {
                    zeroCount++;
                } else {
                    if (zeroCount > 0) {
                        cnNum += digits[0];
                    }
                    zeroCount = 0;
                    cnNum += digits[n] + cnIntRadice[m];
                }

                if (m === 0 && zeroCount < 4) {
                    cnNum += cnIntUnits[q];
                }
            }

            if (decimalPart) {
                let decLen = decimalPart.length;
                for (let i = 0; i < decLen; i++) {
                    let n = parseInt(decimalPart.charAt(i));
                    if (n !== 0) {
                        cnNum += digits[n] + decimals[i];
                    }
                }
            }

            if (isNegative) {
                cnNum = '负' + cnNum;
            }

            return cnNum;
        },

        formatMoney(num) {
            // 将数字转换为字符串并保留两位小数
            num = num.toFixed(2);

            // 将字符串按小数点分割成整数部分和小数部分
            var parts = num.toString().split(".");

            // 将整数部分每三位加一个逗号
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // 将整数部分和小数部分拼接起来
            return parts.join(".");
        },
        formatName(str) {
            if (!str) return '<span style="color:#c4c8d0">请选择关联流程</span>';
            let arrList = str.split('、');
            console.log(arrList.join('\n'))
            return arrList.join('<br>');
        }
    },
};
</script> 
  
<style lang="less" scoped>
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
    display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
    content: '';
    text-align: center;
    line-height: 37px;
}

.file-operate {
    display: flex;
}

.file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
}

.content {
    padding: 0px;
    margin: 0px;

    .title-box {
        border-top: 1px solid #E5E5E5;
        background-color: #ffffff;
        padding: 8px 0px;
        position: relative;

        button {
            font-size: 12px;
            color: #212121;
            letter-spacing: 0;
            width: 60px;
            height: 26px;
            padding: 0px;
            border: 1px solid rgba(217, 217, 217, 1);
            border-radius: 2px;
            position: absolute;
            left: 16px;
            top: 6px;
        }

        span {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
        }
    }

    .mt-4 {
        margin-top: 4px;
    }

    .form-box {
        margin-top: 4px;
        text-align: left;

        .form-title {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            margin-left: 16px;
            font-weight: 500;
        }

        /deep/ .el-row {
            margin: 0px !important;
        }

        .el-form-item {
            margin-bottom: 8px;
        }

        .over-label /deep/ .el-form-item__label {
            line-height: 21px;
        }

        .el-input {
            width: 220px;
        }

        .bottom-btn-box {
            padding: 18px 0px;
            text-align: center;
            border-top: 1px solid #E5E5E5;

            .el-button--primary {
                color: #ffffff;
            }
        }
    }

    /deep/ .el-dialog__header {
        text-align: left;
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px;
    }

    /deep/ .el-dialog__footer {
        padding: 10px 20px;
        border-top: 1px solid #D9D9D9;
    }


    .flow {
        background: #fff;
        padding-left: 20px;
    }

    .iframe-sty {
        width: 100%;
        border: none;
        height: 600px;

    }

    .detail-box {
        height: auto;
        border: 1px solid rgba(217, 217, 217, 1);
        margin: 0px 16px;
        padding: 16px 16px 100px 16px;
    }

    .cannel-btn {
        border: 1px solid rgba(217, 217, 217, 1);
        border-radius: 2px;
        color: #212121;
    }

    .content-main-box2 {
        height: 55vh;
        overflow-x: hidden;

        .search-area {
            padding: 16px 0px;
        }

        .el-table {
            border-left: 1px solid #D8D8D8;
            border-right: 1px solid #D8D8D8;
            border-bottom: 1px solid #D8D8D8;
        }
    }

    .file-img-box {
        display: flex;
        align-items: center;

        img {
            width: 26px;
            height: 26px;
            margin-right: 10px;
        }

        .see-btn {
            font-size: 14px;
            color: #4FA1A4;
            letter-spacing: 0;
            line-height: 21px;
            font-weight: 400;
            cursor: pointer;
            margin-left: 10px;
        }
    }

    .flex-between,
    .form-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-title-box {
        padding-right: 16px;
    }

    h2 {
        text-align: center;
    }

    .txt-right {
        text-align: right;

        span {
            margin: 0px 16px;
        }
    }

    .table1 {
        border: 1px solid rgba(217, 217, 217, 1);

        .header-div {
            background: #F2F2F2;
            font-size: 12px;
            color: #909399;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            height: 32px;
            line-height: 32px;
            font-weight: 500;
        }

        .tab-label {
            padding: 0px 10px;
            width: 200px;
            height: 32px;
            color: #212121;
            line-height: 32px;
            background: #FAFAFA;
            border-top: 1px solid rgba(229, 229, 229, 1);
            border-right: 1px solid rgba(229, 229, 229, 1);
        }

        .tab-value {
            text-align: right;
            padding: 0px 10px;
            width: calc(100% - 200px);
            height: 32px;
            line-height: 32px;
            border-top: 1px solid rgba(229, 229, 229, 1);
            color: #666666;
        }

        p {
            color: #666666;
        }

        .line-box {
            height: 32px;
            line-height: 32px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding-left: 10px;

            div:first-child {

                width: 80px;
                background: #FAFAFA;
                // border-top: 1px solid rgba(229, 229, 229, 1);
                border-right: 1px solid rgba(229, 229, 229, 1);
                font-weight: bold;
            }

            div:last-child {
                padding: 10px 6px;
                width: calc(100% - 80px);

                // border-top: 1px solid rgba(229, 229, 229, 1);
            }
        }
    }

    .table2,
    .table3 {
        border-left: 1px solid rgba(217, 217, 217, 1);
        border-right: 1px solid rgba(217, 217, 217, 1);
        border-bottom: 1px solid rgba(217, 217, 217, 1);
    }

    .table2 {
        margin: 16px 0px;
    }

    .info-box {
        width: calc(50% - 12px);
    }

    .detail {
        border: 1px solid #DCDFE6;
        width: 474px;
        padding: 4px 12px;
        border-radius: 4px;
        line-height: 28px;
        min-height: 26px;
        color: #606266;
        cursor: pointer;
    }
}
</style>
